import styled from "styled-components";

export const ShortcutFormStyled = styled.div`
  form {
    display: flex;
    flex-direction: column;
    row-gap: 65px;
    .box_col_2 {
      display: flex;
      align-items: flex-start;
      column-gap: 40px;
      .obj_switch {
        padding-top: 6px;
        display: flex;
        align-items: center;
        column-gap: 37px;
        span {
          color: ${({ theme }) => theme.COLORS.BLACK_2};
          font-size: ${({ theme }) => theme.FONT.SIZE.S14};
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        }
      }
      .box_select {
        flex-basis: 40%;
        flex-direction: column;
        display: flex;
        row-gap: 12px;
      }
    }
    .btn_zone {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      column-gap: 10px;
      .w120 {
        width: 120px;
      }
    }
  }
`;
